<template>
  <div>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>Solicitudes</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn @click="showCreacion = true" color="primary" small>Crear</v-btn> -->
      </v-toolbar>

      <v-divider></v-divider>

      <v-data-table
        :headers="columns"
        :items="solicitudes"
        item-key="name"
        class="elevation-1"
        :loading="loading"
        loading-text="Cargando..."
        no-data-text="Sin solicitudes"
        dense
      >
        <template v-slot:item.accion="{ item }">
          <v-icon small class="mr-2" @click="goToSolicitud(item)">
            mdi-eye
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <CrearRedencion
      :solicitud="solicitudSelected"
      lockedHasEmision="Redención Normal"
      :show="showModal"
      @close="handleCloseRedencion"
      :mode="modeRedencion"
      :ignoreClientStep="true"
    />

    <CrearSolicitud
      :solicitud="solicitudSelected"
      :show="showModalSolicitud"
      @close="handleCloseSolicitud"
      :mode="modeSolicitud"
      :ignoreClientStep="true"
    />

    <solicitud-dialog
      v-if="showCreacion"
      :show="showCreacion"
      :cliente="cliente"
      categoria="Redención Normal"
      route="/v1/solicitud/manual"
      @close="showCreacion = false"
    ></solicitud-dialog>
  </div>
</template>

<script>
import { getSolicitudesByIdCliente } from "@/services/solicitudService";
import solicitudDialogForm from "./solicitudDialogForm.vue";
import CrearSolicitud from "@/components/solicitudes/modals/CrearSolicitud.vue";
import CrearRedencion from "@/components/solicitudes/modals/CrearRedencion.vue";

export default {
  components: {
    "solicitud-dialog": solicitudDialogForm,
    CrearRedencion,
    CrearSolicitud,
  },

  props: {
    cliente: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      columns: [
        { text: "ID", value: "id" },
        { text: "Nombre", value: "titulo" },
        { text: "Fecha", value: "fechaCreacion" },
        { text: "Status", value: "statusTag" },
        { text: "Tipo", value: "tipo" },
        { text: "Categoría", value: "categoria" },
        { text: "Ver", value: "accion", sortable: false },
      ],
      solicitudes: [],
      loading: false,
      showCreacion: false,
      solicitudSelected: {},
      modeRedencion: "view",
      modeSolicitud: "view",
      showModal: false,
      showModalSolicitud: false,
    };
  },

  mounted() {
    this.getSolicitudes();
  },

  methods: {
    getSolicitudes() {
      if (this.cliente) {
        this.getSolicitudesCliente();
      }
    },

    async getSolicitudesCliente() {
      this.loading = true;
      try {
        const response = await getSolicitudesByIdCliente(this.cliente.id);
        this.solicitudes = response.solicitudes;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    goToSolicitud(solicitud) {
      if (
        solicitud.tipo == "Redención Beneficio" ||
        solicitud.tipo == "Redención Asistencia"
      ) {
        this.solicitudSelected = solicitud;
        this.showModal = true;
      } else {
        this.solicitudSelected = solicitud;
        this.showModalSolicitud = true;
      }
    },

    handleCloseRedencion() {
      this.showModal = false;
      this.solicitudSelected = null;
    },

    handleCloseSolicitud() {
      this.showModalSolicitud = false;
      this.solicitudSelected = null;
    },
  },
};
</script>
